// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import usePaintReady from '@tcp/core/src/hooks/usePaintReady';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import {
  imageStyle,
  Container,
  ImageBannerSkeleton,
} from '../styles/NonClickableImageBanner.style';

export const getClassName = ({
  slot,
  isHomePage,
  pageSlotName,
  isDoubleTile,
  isSingleTile,
  isInGridPromo,
  isPlpTopPromos,
  isFullWidthTile,
  isBundleStaticPage,
  isStaticContentPage,
}) => {
  if (isHomePage) {
    return `${pageSlotName}-home`;
  }

  if (isPlpTopPromos) {
    return 'top-promo-plp';
  }

  if (isStaticContentPage) {
    return `${pageSlotName}-content-page`;
  }

  if (isBundleStaticPage) {
    return `${pageSlotName}-bundle-page`;
  }

  if (isInGridPromo) {
    if (isSingleTile) {
      return `${slot}-single-tile-promo`;
    }
    if (isDoubleTile) {
      return `${slot}-double-tile-promo`;
    }
    if (isFullWidthTile) {
      return `${slot}-full-row-promo`;
    }
  }

  return 'non-clickable-banner';
};

const NonClickableImageBanner = ({ imageData, otherProps }) => {
  const isPaintReady = usePaintReady();
  const containerClassName = getClassName(otherProps);

  return isPaintReady ? (
    <Container className={`${containerClassName}-container`}>
      <DamImage
        width="100%"
        style={imageStyle}
        imgData={imageData}
        className={`${containerClassName}-image`}
        assignKeyValue={imageData.url}
        preloadImage={otherProps.isPreload}
      />
    </Container>
  ) : (
    <ImageBannerSkeleton />
  );
};

NonClickableImageBanner.propTypes = {
  imageData: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }).isRequired,
  otherProps: PropTypes.shape({
    slot: PropTypes.string,
    isPreload: PropTypes.bool,
    isHomePage: PropTypes.bool,
    isSingleTile: PropTypes.bool,
    isDoubleTile: PropTypes.bool,
    isInGridPromo: PropTypes.bool,
    isPlpTopPromos: PropTypes.bool,
    pageSlotName: PropTypes.string,
    isFullWidthTile: PropTypes.bool,
    isBundleStaticPage: PropTypes.bool,
    isStaticContentPage: PropTypes.bool,
  }),
};

NonClickableImageBanner.defaultProps = {
  otherProps: {
    slot: '',
    isPreload: false,
    pageSlotName: '',
    isHomePage: false,
    isDoubleTile: false,
    isSingleTile: false,
    isInGridPromo: false,
    isPlpTopPromos: false,
    isFullWidthTile: false,
    isBundleStaticPage: false,
    isStaticContentPage: false,
  },
};

export default React.memo(NonClickableImageBanner, () => true);
